import {DeviceListScreen} from './DeviceListScreen';
import {RouteDefinition} from '../../../routes';
import {DeviceEditScreen} from './DeviceEditScreen';
import {DeviceSettingsScreen} from './DeviceSettingsScreen';

export const DeviceSettingsRoutes: RouteDefinition[] = [
    {
        name: 'CİHAZ OLUŞTUR',
        routerLink: '/settings/device/edit',
        component: DeviceEditScreen,
    },
    {
        name: 'CİHAZ DÜZENLE',
        routerLink: '/settings/device/edit/:id',
        component: DeviceEditScreen,
    },
    {
        name: 'CİHAZ AYARLARI',
        routerLink: '/settings/device/device-settings/:id',
        component: DeviceSettingsScreen,
    },
    {
        name: 'CİHAZ AYARLARI',
        routerLink: '/settings/device',
        component: DeviceListScreen,
    },
];
